<script setup lang="ts">
import type { TCarouselProps } from '../model/common';

import { ProductCard } from '~/features/product-card';
import CarouselSlides from './CarouselSlides.vue';

import { useFavorites } from '~/features/store/favorite';
import { getPopularProducts } from '../business/getPopularProducts';

defineProps<TCarouselProps>();

const products = ref([]);
const { handleFavoriteToggleCurried } = useFavorites();
const { buildAnalyticsParams } = await import('@/features/store/favorite/business/analyticsParams');
const handleFavoriteToggle = handleFavoriteToggleCurried('productCarousel');

const handleFavoriteToggleWithParams = async (product: any, index: number) => {
  const extraParams = await buildAnalyticsParams('сarousel', product, {
    index,
    moduleName: 'Популярные товары',
    moduleId: 'popular-slider',
    carouselPosition: 3,
    moduleSize: 'small'
  });

  await handleFavoriteToggle(product, extraParams);
};
getPopularProducts().then((r) => (products.value = r));
</script>

<template>
  <CarouselSlides title="Популярные товары" :products="products">
    <template #default="{ product, position }">
      <ProductCard
        :product="product"
        :addToCartFn="addToCartFn"
        :tracker-product-click="{
          enabled: trackerProductClick?.enabled,
          additionalPayload: { position, ...trackerProductClick?.additionalPayload },
        }"
        :tracker-product-view="{
          enabled: trackerProductView?.enabled,
          additionalPayload: { position, ...trackerProductView?.additionalPayload },
        }"
        @favorite-toggle="(p) => handleFavoriteToggleWithParams(p, position)"
      />
    </template>
  </CarouselSlides>
</template>
